import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const SourceTypeSelect = ({ selectedSourceType, handleSourceTypeChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="source-type-label">Source Type</InputLabel>
      <Select
        labelId="source-type-label"
        id="source-type"
        value={selectedSourceType}
        label="Source Type"
        onChange={handleSourceTypeChange}>
        <MenuItem value="article">Article</MenuItem>
        <MenuItem value="article-journal">Journal Article</MenuItem>
        <MenuItem value="article-magazine">Magazine Article</MenuItem>
        <MenuItem value="article-newspaper">Newspaper Article</MenuItem>
        <MenuItem value="book">Book</MenuItem>
        <MenuItem value="broadcast">Broadcast</MenuItem>
        <MenuItem value="document">Document</MenuItem>
        <MenuItem value="interview">Interview</MenuItem>
        <MenuItem value="map">Map</MenuItem>
        <MenuItem value="post">Post</MenuItem>
        <MenuItem value="report">Report</MenuItem>
        <MenuItem value="review">Review</MenuItem>
        <MenuItem value="thesis">Thesis</MenuItem>
        <MenuItem value="webpage">Webpage</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SourceTypeSelect;
